// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__3c3hY","title":"ClientInsurance_title__FslNX","itemText":"ClientInsurance_itemText__kE-6u"};